/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  priceData reducer
 */

import type { PriceChart } from '@zcode/state-type'
import { combineReducers } from 'redux'
import type { ActionTypes } from '../types'
import { cityDataReducer, hoodDataReducer } from './data'
import { cityMetaReducer, hoodMetaReducer } from './meta'

export const detailPriceChart = combineReducers<PriceChart, ActionTypes>({
  cityPriceData: cityDataReducer,
  cityPriceMeta: cityMetaReducer,
  hoodPriceData: hoodDataReducer,
  hoodPriceMeta: hoodMetaReducer,
})
